import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { Button } from '@/components/ui/button';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent, useEditorState } from '@tiptap/react';
import { ExternalLinkIcon } from 'lucide-react';
import { memo } from 'react';

const ZyClassicLabNodeView: React.FC<ReactNodeViewProps> = ({ editor, selected, decorations }) => {
    const { zybookCode, chapterNumber, sectionNumber } = useEditorState({
        editor,
        selector: ({ editor: ed }) => ({
            zybookCode: ed?.state.doc.attrs.zybookCode ?? null,
            chapterNumber: ed?.state.doc.attrs.chapterNumber ?? null,
            sectionNumber: ed?.state.doc.attrs.sectionNumber ?? null,
        }),
    });

    const hasLocation = Boolean(zybookCode && chapterNumber != null && sectionNumber != null);
    const iframeUrl = hasLocation
        ? `${import.meta.env.VITE_ZYBOOKS_URL}/zybook/${zybookCode}/chapter/${chapterNumber}/section/${sectionNumber}/edit?hideLabSpec=true`
        : '';

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="zyClassicLab"
            selected={selected}
            contentClassName="px-4 py-4"
        >
            <NodeViewContent />
            <div
                className="min-h-[600px] h-[600px] rounded border border-gray-300 bg-gray-50"
                contentEditable={false}
            >
                {!hasLocation ? (
                    <div className="flex h-[600px] flex-col items-center justify-center">
                        <p className="text-gray-500">Document zyBook code, chapter, and section are required to load the lab editor.</p>
                    </div>
                ) : (
                    <iframe
                        src={iframeUrl}
                        className="h-full w-full border-0"
                        title="zyClassicLab editor"
                    />
                )}
            </div>
            <div className="flex justify-end">
                <Button
                    variant="link"
                    size="sm"
                    className="cursor-pointer text-blue-500 hover:text-blue-600"
                    disabled={!hasLocation}
                    onClick={() => {
                        window.open(iframeUrl, '_blank');
                    }}
                >
                    <ExternalLinkIcon className="w-4 h-4 mr-2" /> Open in new tab
                </Button>
            </div>
        </CommonNodeViewWrapper>
    );
};

export default memo(ZyClassicLabNodeView);
